import React from "react";
import { Icons } from "@learningblocks/exp-constants";
import { Colours } from "@learningblocks/shared-components";

const { CorrectSquareSolid, InCorrectSquareSolid: InCorrectSquareSolid } =
  Icons;

const CORRECT_ICON_STYLE = {
  fill: Colours.colorFeedbackSuccess,
  height: "100%",
};
const INCORRECT_SELECT_ICON_STYLE = {
  fill: Colours.colorFeedbackFail,
  height: "100%",
};
const INCORRECT_ICON_STYLE = {
  fill: Colours.colorNeutralGray4,
  height: "100%",
};

export const CorrectSolidIcon = () => (
  <CorrectSquareSolid style={CORRECT_ICON_STYLE} />
);
export const InCorrectSolidIcon = () => (
  <InCorrectSquareSolid style={INCORRECT_SELECT_ICON_STYLE} />
);
export const InCorrectSolidInvalid = () => (
  <InCorrectSquareSolid style={INCORRECT_ICON_STYLE} />
);
